<template>
  <frontoffice-frame class="chat-new-discussion">
    <page-title>
      <span>{{ $t(title) }}</span>

      <span class="text-right">

      <button class="orange-white btn" @click="goBack()">{{ $t('_back') }}</button>

      <back-button v-if="!isCancellation" name="home_message_list"
                   class="buttons-link orange-white btn"
      >
        {{ $t('message.show.show') }}
      </back-button>
      </span>
    </page-title>

    <b-row class="justify-content-center align-items-center">
      <p class="col-12 col-lg-10 col-xl-8 message-for-user" v-html="$t(intro)" />
    </b-row>

    <b-row class="new-message-section justify-content-center align-items-center">
      <div v-if="!isCancellation" class="col-12 col-lg-10 col-xl-8 subject">
        <text-input :label="$t('message.subject')"
                    @input="setItem('subject', $event)"
                    name="subject" :required="false"
        />
      </div>

      <div class="col-12 col-lg-10 col-xl-8 new-message">
        <textarea name="new_message" @input="setTextAreaItem('content', $event)" />
      </div>
    </b-row>

    <b-row class="justify-content-center">
      <div class="col-12 col-lg-10 col-xl-8">
        <b-row class="justify-content-center">
          <div class="col-md-6 upload-group">
            <file-input :types="fileTypes" @input="setItem('file', $event)" placeholder=" " id="tooltip-upload" class="bg-light">
              <template slot="file-name" slot-scope="{ names }">
                <b-badge class="orange-white">{{ names[0] }}</b-badge>
              </template>
            </file-input>
            <b-tooltip target="tooltip-upload" triggers="hover">
                {{ $t('_tooltip.upload' )}}
            </b-tooltip>
          </div>
          <div class="col-md-6">
            <button class="btn orange-white width-max" @click="sendMessage">
              {{ $t('_send') }}
            </button>
          </div>
        </b-row>
      </div>
    </b-row>
    <div v-if="success !== null" class="col-lg-6 offset-lg-3">
      <b-alert :variant="this.success ? 'success' : 'danger'" show>
        <span v-if="success">{{ $t('message.alert.success' )}}</span>

        <ul v-else>
          <li v-for="error in errors" :key="error.id">
            <b>{{ $t(`message.fields.${error.field}`) }} :</b>
            {{ $t(`error.${error.code}`) }}
          </li>
        </ul>
      </b-alert>
    </div>
  </frontoffice-frame>
</template>

<script>
import CommonApi from '@/api/commonApi'
import FormSubmitter from '@/api/formSubmitter'
import frontofficeFrame from '@/components/frontoffice/frame'
import pageTitle from '@/components/frontoffice/pageTitle'
import textInput from '@/components/frontoffice/form/baseInput/text'
import backButton from '@/components/frontoffice/button/back'
import fileInput from '@/components/frontoffice/form/baseInput/file'
import messageMixin from '@//components/frontoffice/mixins/message'

export default {
  components: {
    frontofficeFrame,
    pageTitle,
    textInput,
    backButton,
    fileInput
  },

  mixins: [messageMixin],

  data () {
    return {
      commonApi: new CommonApi(),
      subject: '',
      content: '',
      file: null,
      success: null,
      isCancellation: this.$route.params.action === 'cancel',
      errors: [],
      formData: new FormData()
    }
  },

  created () {
    this.formData.set('bookingId', this.$route.params.id || null)
  },

  methods: {
    setItem (key, value) {
      this.formData.set(key, value)
    },

    setTextAreaItem (key, event) {
      // textArea : on récupère la valeur du textarea depuis l'event triggered
      this.formData.set(key, event.target.value)
    },

    sendMessage () {
      this.success = null
      this.errors = []

      if (this.isCancellation) {
        let submitter = new FormSubmitter('booking_cancel')
        submitter.submitRequest(
          { cancellation_comment: this.formData.get('content') },
          this.formData.get('bookingId')
        )
          .then(response => {
            this.dealResponse(response)
          })
      } else {
        this.commonApi.sendParentMessage(this.formData)
          .then(response => {
            this.dealResponse(response)
          })
      }
    },

    dealResponse (response) {
      if (response.data.success) this.dealSuccess()
      else this.dealFailure(response.data.errors)
    },

    dealSuccess () {
      this.success = true
      setTimeout(() => {
        this.goBack()
      }, 5000)
    },

    dealFailure (errors) {
      this.success = false
      for (let i in errors) {
        if (errors.hasOwnProperty(i)) {
          this.errors.push({
            field: i,
            code: errors[i]
          })
        }
      }
    },

    goBack () {
      this.$router.go(-1)
    }
  },

  computed: {
    title () {
      return 'message.' + (this.isCancellation ? 'cancelMessage.title' : 'newMessages.newMessage')
    },

    intro () {
      return 'message.text.' + (this.isCancellation ? 'cancel' : 'default')
    }
  }
}
</script>
